import React, { Component } from "react";
import axios from "axios";
import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Navigate } from "react-router-dom";

import { Card, Grid, TextField, Select, MenuItem } from "@mui/material";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";

export default class UpdateSubject extends Component {
  state = {
    subject_id: "",
    subject_name: "",
    level_id: "",
    course_id: "",
    team_id: "",
    meta_key: "",
    meta_description: "",
    levels: [],
    courses: [],
    teams: [],

    loading: false,
    notification: false,
    message: "",
    notiColor: "success",
    redirect: false,
  };

  componentDidMount() {
    this.getDropdownData();
    this.getSingleSubject();
  }

  // ✅ FETCH DROPDOWNS
  getDropdownData = async () => {
    try {
      const [levels, courses, teams] = await Promise.all([
        axios.post(Constants.getUrls.getAllLevels, { page: 1, limit: 100 }),
        axios.post(Constants.getUrls.getAllCourses, { page: 1, limit: 100 }),
        axios.post(Constants.getUrls.getAllTeams, { page: 1, limit: 100 }),
      ]);

      this.setState({
        levels: levels.data.data.rows || [],
        courses: courses.data.data.rows || [],
        teams: teams.data.data.rows || [],
      });
    } catch (err) {
      console.log(err);
    }
  };

  // ✅ FETCH SINGLE SUBJECT
  getSingleSubject = async () => {
    const subject_id = window.location.pathname.split("/")[2];

    try {
      const resp = await axios.post(Constants.getUrls.getSubjectDetails, {
        id: subject_id,
      });

      if (resp.data.status) {
        const data = resp.data.data;

        this.setState({
          subject_id: data.id,
          subject_name: data.subject_name,
          level_id: data.level_id,
          course_id: data.course_id,
          team_id: data.team_id,
          meta_key: data.meta_key || "",
          meta_description: data.meta_description || "",
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  // ✅ INPUT HANDLER
  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  // ✅ UPDATE SUBJECT
  handleSubmit = async (e) => {
    e.preventDefault();

    const {
      subject_id,
      subject_name,
      level_id,
      course_id,
      team_id,
      meta_key,
      meta_description,
    } = this.state;

    if (!subject_name || !level_id || !course_id || !team_id) {
      return this.setState({
        notification: true,
        message: "All fields are required!",
        notiColor: "warning",
      });
    }

    if (init() !== "success") {
      window.location.assign("/signin");
      return;
    }

    const payload = {
      id: subject_id,
      subject_name,
      level_id,
      course_id,
      team_id,
      role_id: 1, // ✅ fixed
      meta_key,
      meta_description,
    };

    this.setState({ loading: true });

    try {
      const resp = await axios.post(Constants.putUrls.updateSubject, payload);

      this.setState({
        notification: true,
        message: resp.data.message || "Updated successfully!",
        notiColor: "success",
        loading: false,
      });

      setTimeout(() => {
        this.setState({ redirect: true });
      }, 1500);
    } catch (err) {
      this.setState({
        notification: true,
        message: err?.response?.data?.message || "Something went wrong!",
        notiColor: "warning",
        loading: false,
      });
    }
  };

  render() {
    if (this.state.redirect) return <Navigate to="/subjects" />;

    return (
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={6} pb={3}>
          <Card style={{ padding: 20 }}>
            <MDBox
              mx={2}
              mt={-6}
              py={3}
              px={2}
              bgColor="info"
              borderRadius="lg"
            >
              <MDTypography variant="h6" color="white">
                Update Subject
              </MDTypography>
            </MDBox>
            <form onSubmit={this.handleSubmit}>
              <Grid container spacing={2} mt={1}>
                {/* SUBJECT NAME */}
                <Grid item sm={6}>
                  <TextField
                    label="Subject Name"
                    name="subject_name"
                    value={this.state.subject_name}
                    onChange={this.handleInput}
                    fullWidth
                  />
                </Grid>

                {/* LEVEL */}
                <Grid item sm={6}>
                  <Select
                    name="level_id"
                    value={this.state.level_id}
                    onChange={this.handleInput}
                    fullWidth
                    displayEmpty
                    style={{ width: "100%", height: "45px", color: "#fff" }}
                  >
                    <MenuItem value="">Select Level</MenuItem>
                    {this.state.levels.map((l) => (
                      <MenuItem key={l.id} value={l.id}>
                        {l.title}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>

                {/* COURSE */}
                <Grid item sm={6}>
                  <Select
                    name="course_id"
                    value={this.state.course_id}
                    onChange={this.handleInput}
                    fullWidth
                    displayEmpty
                    style={{ width: "100%", height: "45px", color: "#fff" }}
                  >
                    <MenuItem value="">Select Course</MenuItem>
                    {this.state.courses.map((c) => (
                      <MenuItem key={c.id} value={c.id}>
                        {c.course_name}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>

                {/* TEAM */}
                <Grid item sm={6}>
                  <Select
                    name="team_id"
                    value={this.state.team_id}
                    onChange={this.handleInput}
                    fullWidth
                    displayEmpty
                    style={{ width: "100%", height: "45px", color: "#fff" }}
                  >
                    <MenuItem value="">Select Team</MenuItem>
                    {this.state.teams.map((t) => (
                      <MenuItem key={t.id} value={t.id}>
                        {t.name}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>

                {/* META KEYS */}
                <Grid item sm={12}>
                  <TextField
                    label="Meta Keywords (SEO)"
                    name="meta_key"
                    value={this.state.meta_key}
                    onChange={this.handleInput}
                    fullWidth
                  />
                </Grid>
                <Grid item sm={12}>
                  <TextField
                    label="Meta Description"
                    name="meta_description"
                    multiline
                    rows={4}
                    value={this.state.meta_description}
                    onChange={this.handleInput}
                    fullWidth
                  />
                </Grid>

                {/* SUBMIT */}
                <Grid item sm={12}>
                  <MDButton type="submit" variant="contained" color="info">
                    {this.state.loading ? "Updating..." : "Update Subject"}
                  </MDButton>
                </Grid>
              </Grid>
            </form>
          </Card>

          <MDSnackbar
            color={this.state.notiColor}
            title="Subjects"
            content={this.state.message}
            open={this.state.notification}
          />
        </MDBox>
      </DashboardLayout>
    );
  }
}
